import request from '@/utils/request'

const url = '/home/cooperation/'
const api = {
  subSupplier (data) {
    return request({
      url: url + 'subSupplier',
      method: 'post',
      data
    })
  },
  getSupplier (data) {
    return request({
      url: url + 'getSupplier',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/cooperation.js